import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { format } from 'date-fns';
import { HoverCard, HoverCardContent, HoverCardTrigger } from '../overlay/hover-card.js';
import { cn } from '../lib/cn.js';
/**
 * <DateDisplay> — Gregorian, en-only. Phase 1 stripped the Jalali
 * dual-calendar rendering inherited from upstream; future locales can
 * reintroduce alternate calendars via the same shape.
 */
export function DateDisplay({ date, variant = 'short', className, }) {
    const d = typeof date === 'object' ? date : new Date(date);
    const primary = variant === 'short' ? format(d, 'yyyy-MM-dd') : format(d, 'PPP');
    const long = format(d, 'PPP');
    return (_jsxs(HoverCard, { openDelay: 150, children: [_jsx(HoverCardTrigger, { asChild: true, children: _jsx("time", { dateTime: d.toISOString(), className: cn('font-mono tabular-nums', className), children: primary }) }), _jsx(HoverCardContent, { className: "w-auto min-w-40", children: _jsx("div", { className: "text-xs", children: long }) })] }));
}
